import React from 'react';

const OrderStatusesContext = React.createContext([]);

export default OrderStatusesContext